import { ModalBase } from "../../../components/Modals/ModalBase";

export default function ModalAnularDTE ({warning, title, actionConfirm, onCancel, detailDoc} : {warning: string, title: string, actionConfirm: () => void, onCancel: () => void, detailDoc?: string}){
    return(
        <ModalBase>
        <div className='modal-card'>
          <div className='modal-content'>
            <div className='w-layout-hflex'>
              <h3 className='card-title l'>{title}</h3>
            </div>
            <div className='form-separator'></div>
            <div>
            <p>Estás a punto de anular este documento, ¿deseas continuar?</p>
            {detailDoc && (<p><b>Documento:</b> {detailDoc} </p>)}
          </div>
          <p style={{color: '#019FC5'}}>Nota: ten en cuenta que no podrás visualizar el documento, porque estará anulado y te redirigirá a realizar un nuevo documento.</p>
            <div className='form-separator'></div>
            <div className='w-layout-hflex button-actions'>
              <button
                className='m button transparent w-inline-block'
                onClick={onCancel}
              >
                <div>Cancelar</div>
              </button>
              <button 
                className='m button delete w-inline-block' 
                onClick={actionConfirm}
              >
                <div>Anular</div>
              </button>
            </div>
          </div>
        </div>
      </ModalBase>
    )
}